import { Stack, Typography } from "@mui/material";
import { DEFAULT_TIME_ZONE } from "constant";
import { useRouteLoaderData } from "react-router-dom";
import { User } from "type/model/api";
import { MissionAssetView, ShiftView } from "type/model/view";
import { shiftLabel } from "utility/shift";

interface Props {
  missionAsset: MissionAssetView | null;
  shift?: ShiftView | null;
}

export const MissionAssetIdentifier = ({ missionAsset, shift }: Props) => {
  const { currentUser } = useRouteLoaderData("main") as { currentUser: User };

  if (!missionAsset) {
    return null;
  }

  const shiftText = shiftLabel(shift, currentUser.time_zone || DEFAULT_TIME_ZONE);

  return (
    <Stack sx={{ whiteSpace: "nowrap" }}>
      <Typography variant="body2">{missionAsset.name}</Typography>
      {missionAsset.callSign ? <Typography variant="body2">{missionAsset.callSign}</Typography> : null}
      {missionAsset.registration ? <Typography variant="body2">{missionAsset.registration}</Typography> : null}
      {shiftText ? <Typography variant="body2">{shiftText}</Typography> : null}
    </Stack>
  );
};
